import React from 'react';
import { BASELINE_YEARS, PERFORMANCE_YEAR, FALLBACK_YEAR } from '../utils/newApi';

function Footer() {
  // Format baseline years for display (e.g., "2022/2023 - 2024/2025")
  const firstBaselineYear = BASELINE_YEARS[0].replace('-', '/');
  const lastBaselineYear = BASELINE_YEARS[BASELINE_YEARS.length - 1].replace('-', '/');
  const baselineYearsDisplay = `${firstBaselineYear} - ${lastBaselineYear}`;
  
  // Format performance and fallback years for display
  const performanceYearDisplay = PERFORMANCE_YEAR.replace('-', '/');
  const fallbackYearDisplay = FALLBACK_YEAR.replace('-', '/');
  
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/pd_logo_small.png" alt="Project Donor Logo" className="logo-image" />
          <span>Built by <strong>Project Donor</strong></span>
        </div>
        <div className="footer-contact">
          Questions? Feedback? Email <a href="mailto:info@projectdonor.org">info@projectdonor.org</a>
        </div>
        <div className="footer-disclaimer">
          <p>This is an unofficial estimate of the upside/downside payments per Medicare FFS transplant based on the <a href="https://www.cms.gov/priorities/innovation/innovation-models/iota">IOTA Model</a> out of The Center for Medicare and Medicaid Innovation (CMMI).
            <br/>The data is sourced from the <a href="https://www.srtr.org/reports/program-specific-reports">SRTR Program-Specific reports</a>, using July to July data. 
            <br/>The baseline years are currently {baselineYearsDisplay}. 
            <br/>The performance year ({performanceYearDisplay}) is estimated using the most recent SRTR release (currently {fallbackYearDisplay}).
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
